import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

import { listMutations } from './types';

const filter = {
	FromDate: null as Date | null,
	ToDate: null as Date | null,
	CustomerId: null as number | null,
	WorkshopId: null as number | null,
	PaymentMethod: null as number | null,
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		WorkshopId: [],
		PaymentMethod: [],
	},
	filter,
	tableSetting: {
		isEditable: true,
		columnSettings: {
			VALUE: { isEditable: true, required: true },
		},
	},
	localState: {
		CustomerId: null as number | null,
		CustomerText: null as string | null,
	},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[listMutations.ACOOUNTING_ZAKAZNIK_FILTER_SELECT_MAPPER](state, { data }) {
			state.localState.CustomerId = data.value;
			state.localState.CustomerText = data.text;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
